import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export enum CampaignDialogKey {
  NON_ATS_UPLOAD_CANDIDATES = 'nonAtsUploadCandidatesDialogHide',
  NON_ATS_GENERATE_LINK = 'nonAtsGenerateLinkDialogHide',
  NON_ATS_CONNECT_TO_ANALYSIS = 'nonAtsConnectToAnalysisDialogHide',
  ATS_FOR_ALL_CANDIDATES = 'atsForAllCandidatesDialogHide',
  ATS_FOR_ALL_APPLICANTS_IN_ANALYSIS = 'atsForAllApplicantsInAnalysisDialogHide',
  ATS_FOR_PASSIVE_CANDIDATES = 'atsForPassiveCandidatesDialogHide'
}

type CampaignDialogsState = Record<CampaignDialogKey, boolean>;

interface CampaignDialogsActions {
  setDialogHidden: (dialogKey: CampaignDialogKey, hidden: boolean) => void;
  resetDialogs: () => void;
}

type CampaignDialogsStore = CampaignDialogsState & CampaignDialogsActions;

const initialState: CampaignDialogsState = Object.fromEntries(
  Object.values(CampaignDialogKey).map((key) => [key, false])
) as CampaignDialogsState;

export const useCampaignDialogsStore = create<CampaignDialogsStore>()(
  persist(
    (set) => ({
      ...initialState,
      setDialogHidden: (dialogKey, hidden) =>
        set((state) => ({
          ...state,
          [dialogKey]: hidden
        })),
      resetDialogs: () => set(initialState)
    }),
    {
      name: 'campaignCreationDialogs'
    }
  )
);
